'use strict';

var Hounisen = Hounisen || {};
Hounisen.totop = new function () {

    function init() {
        // Init functions
        Totop();
    }

    function Totop() {


        var topButton = document.getElementById("totop");


        //check if user scrolled down more than 30%

        window.addEventListener("scroll", function() {

            if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
                topButton.classList.add("show-top");
            } else {
                topButton.classList.remove("show-top");
            }

        });


        topButton.addEventListener("click",function() {

            //Scroll smoothly to top
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });

        });


    }

    return {
        init: init,
    };
}();
